import { render, staticRenderFns } from "./UploadReceipt.vue?vue&type=template&id=a3a90d08&"
import script from "./UploadReceipt.vue?vue&type=script&lang=js&"
export * from "./UploadReceipt.vue?vue&type=script&lang=js&"
import style0 from "./UploadReceipt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports